export default __webpack_public_path__ + "static/assets/d6f1f594a486809ffd7c787a7c29ef43.gif";